import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Icon, HelpBlock, Divider, Input, Schema } from 'rsuite';
import styled from 'styled-components';

const StyledIcon = styled(Icon)`
  color: #ffb300;
  font-size: 18px;
  margin-right: 5px;
`;

const AutoWidthModal = styled(Modal)`
  width: auto;
  max-width: 500px;
  padding: 0 5px;
  margin: 20px auto;
`;

const { StringType } = Schema.Types;
const emailType = StringType().isEmail();

function NotifyGuestConfirmationModal({
  show,
  onConfirm,
  onSkip,
  onCancel,
  onChangeEmail,
  showEmailField,
  email,
  isSaving,
  ...props
}) {
  const [emailInput, setEmailInput] = useState(email);
  const hasEmailInput = !!emailInput;
  const isMissingRequiredEmail = !email && !hasEmailInput;
  const isInvalidEmail = hasEmailInput && emailType.check(emailInput).hasError;
  const disabledNotifyButton = isMissingRequiredEmail || isInvalidEmail;

  const handleOnChangeEmail = value => {
    setEmailInput(value);
    if (!emailType.check(value).hasError) {
      onChangeEmail(value);
    }
  };

  return (
    <AutoWidthModal
      size="md"
      backdrop="static"
      onHide={onCancel}
      show={show}
      {...props}
    >
      <Modal.Header>
        <Modal.Title>
          <StyledIcon icon="remind" />
          Would you like to notify the guest about this change?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ fontSize: 15 }}>
        {email && (
          <div>
            Notify guest on email: <strong>{email}</strong>
          </div>
        )}
        {(showEmailField || !email) && (
          <Fragment>
            {email && <Divider>Or</Divider>}
            <Input
              placeholder="Provide a valid email address"
              onChange={handleOnChangeEmail}
              type="email"
              name="notifyEmail"
              disabled={isSaving}
            />
            <HelpBlock style={{ padding: 6 }}>
              Note: This will automatically update email record
            </HelpBlock>
          </Fragment>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          color="orange"
          appearance="ghost"
          onClick={onSkip}
          disabled={isSaving}
        >
          <Icon icon="close-circle" /> No, continue without notifying
        </Button>
        <Button
          color="green"
          appearance="ghost"
          onClick={onConfirm}
          disabled={disabledNotifyButton || isSaving}
          loading={isSaving}
        >
          <Icon icon="check-circle" /> Yes, notify guest
        </Button>
      </Modal.Footer>
    </AutoWidthModal>
  );
}

NotifyGuestConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChangeEmail: PropTypes.func.isRequired,
  showEmailField: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
  isSaving: PropTypes.bool
};

NotifyGuestConfirmationModal.defaultProps = {
  isSaving: false
};

export default NotifyGuestConfirmationModal;
